import { render, staticRenderFns } from "./order-table.vue?vue&type=template&id=8d6c33f4&scoped=true&"
import script from "./order-table.component.ts?vue&type=script&lang=ts&"
export * from "./order-table.component.ts?vue&type=script&lang=ts&"
import style0 from "./order-table.scss?vue&type=style&index=0&id=8d6c33f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6c33f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d6c33f4')) {
      api.createRecord('8d6c33f4', component.options)
    } else {
      api.reload('8d6c33f4', component.options)
    }
    module.hot.accept("./order-table.vue?vue&type=template&id=8d6c33f4&scoped=true&", function () {
      api.rerender('8d6c33f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery/components/order-table/order-table.vue"
export default component.exports